import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import SelectUi from './Select/ui/SelectUi'

type BooleanProps = {
  labelText: string
  update: (value: boolean) => void
  value?: boolean
}

const Boolean = ({ labelText, update, value }: BooleanProps) => {
  const { t } = useTypedTranslation()
  return (
    <OptionWrapper labelText={labelText}>
      <SelectUi
        onChange={e => update(e.target.value === 'on')}
        value={value ? 'on' : 'off'}
        data-test-element="boolean-select"
      >
        <option value="on">{t('on')}</option>
        <option value="off">{t('off')}</option>
      </SelectUi>
    </OptionWrapper>
  )
}

export default Boolean
